import { BookCategoryManagement } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for category management in the admin section.
 * @returns {Array} An array containing the route objects for category management.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.CATEGORY_MANAGEMENT.path,  // URL path for category management
      name: "Category Management",  // Display name for the route
      key: adminRouteMap.CATEGORY_MANAGEMENT.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.CATEGORY_MANAGEMENT.icon,  // Icon associated with category management
      element: <BookCategoryManagement />,  // Component to render for category management route
    }
  ];
}
